import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    typography: {
        fontFamily: "SpaceGrotesk, sans-serif",
        allVariants: {
            fontFamily: "SpaceGrotesk, sans-serif",
        },
    },
    palette: {
        missionGold: {
            // main: "#E0A800",
            main: "#fff",
            cream: "#F8F5E9"
        }
    },

    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: "SpaceGrotesk, sans-serif",
                },
            },
        },
    },
});

export default theme;